<div style="background-image: url('assets/images/performrx_background.jpg');" class="dynamic-bg">
<div class="dashboard-container">
  <div style="margin-bottom: 20px;">
     <img src="assets/images/logo-performrx-background.png" alt="Performrx logo" width="20%">
  </div>
  <!-- <header>
    <h1>Welcome to <span style="color: #b5121b;">PerformPBI</span></h1>
  </header> -->
    <div style="text-align: -webkit-center;">
    <section class="dashboard-content">
      <h2>Smarter Data-driven Decisions Start Here</h2>
      <p style="padding-bottom: 6px;">
        <span style="color: #b5121b;"><b>PerformPBI</b></span> is your hub for pharmacy business intelligence, giving you current data and analytics to help you make smarter decisions, faster. Built by our team of experts, the platform lets you track performance, spot financial trends, and monitor key metrics − all in one place.
      </p>
       <!-- <br/> -->
      <p  style="padding-bottom: 4px;">Designed to cut through the noise, PerformPBI gives you the insights you need to make confident and data-driven decisions.</p>
      <!-- <br/> -->
      <h2>Key Features</h2>
      <ul><li> Instant access to real-time insights</li>
        <li> Customizable KPI tracking</li>
        <li> Interactive filters and powerful data visuals</li>
        <li> Clean and simple dashboards</li>
      </ul>
      <!-- <br/> -->
      <p style="padding-top: 4px;">
        To request a demo or learn more about PerformRx’s integrated data management solutions, contact your Account Manager.
      </p>
    </section>  

   </div>
  <!-- </div> -->
</div>
</div>